import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GridOptions } from "ag-grid-community";
import { id } from '@swimlane/ngx-charts';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AssetService } from 'src/app/_services/asset.service';
import { GlobalConsignmentService } from 'src/app/_services/global-consignment.service';
import { GlobalRequisitionService } from 'src/app/_services/global-requisition.service';
import { InventoryService } from 'src/app/_services/inventory.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { ProductService } from 'src/app/_services/product.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { onlyWholeNumbersValidator } from "src/app/shared/numberValiator";
import { TableHeaderToolTipComponent } from 'src/app/shared/table-header-tool-tip/table-header-tool-tip.component';
import { SelectAllComponent } from 'src/app/renderer/select-all.component';
import * as _ from 'lodash';
import { GridSelectionService } from 'src/app/_services/grid-selection.service';
var statusesJS: any = [];
@Component({
    selector: 'app-edit-requisition-notes',
    templateUrl: './edit-requisition-notes.component.html',
    styleUrls: ['./edit-requisition-notes.component.scss'],
    standalone: false
})
export class EditRequisitionNotesComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
  type: any;
  transferType: any
  data: any
  requestTypeOption:any

  addAssetTypeForm: UntypedFormGroup[] = [];
    assetType: any;
    totalQuantity: any;
    totalCustomFormQuantity: any;
  userId: string;
  //Asset Type Variables
  assetTypes: any;
  categoryList: any;
  subCategoryList: any;
  assetstatuses: any;
  filter: any = {
    assetTypes: null,
    assetStatuses: null,
  };

//// On Save =====
  submitTouched: boolean;
  requisitionValues:any[]=[]
  requisitions: any;

  productsFamilies: any[];
  productsType: any;
selectedRows: any = [];
  ///Bin Transfer Variables
  showToBinTransferTable: boolean;
  selectedToBinTransfer: any;
  TobinPickList: any;
  filteredToBinPickList: any[];
  requisitionData: any[]=[];


  //Filter Variables
  filteredBinPickList: any[]; // 
  binPickList: any;
  showBinTransferTable: boolean = false;
  dummyData: any = [];
  assets: any;
  selectAllChecked: any = false;
  totalRecord: any;
  filterAPILoaded: boolean = false;

   public noData: boolean | null = null;
  public create!: boolean;
  public searchValue = "";
  public search: any;
  public filterActive = false;
  isFilterSectionClosed!: boolean;


  //Grid Variables
  gridApi: any;
    gridColumnApi: any;
    public columnDefs: any;
    public defaultColDef: any;
    public frameworkComponents: any;
    gridParams: any;
    parameters: any;
    public gridOptions:any 
    public overlayNoRowsTemplate!: string;
  
selectedRowIds: Set<string> = new Set();
initSelectedRows:boolean = true;
  products: any;
  selectedIndex: any;
  displayProductTable: boolean;
  isFromBinInvalid: boolean;

  //Bin Transfer Variables
  showTransferTable: boolean;
  selectedTransfer: any;
  transferPicklist: any;
  isTransferInvalid: boolean;
  searchValueData: boolean;
  productsData: any;

  constructor(
    public modalRef : BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private route: ActivatedRoute,
    private errorUtil: ErrorUtil,
    private fb: FormBuilder,
    private globalRequisitionService:GlobalRequisitionService,
    private globalConsignmentService:GlobalConsignmentService,
    private spinner: NgxSpinnerService,
    private assetService: AssetService,
    private productService: ProductService,
    private auth: AuthenticationService,
   private inventoryServices: InventoryService,
   private gridSelectionService: GridSelectionService
  ) { 
    super();
     this.frameworkComponents = {
          selectAllComponent: SelectAllComponent,
        };
        this.gridOptions = {
          cacheBlockSize: 525,
          rowModelType: "clientSide",
          paginationPageSize: 25,
          sortingOrder: ["desc", "asc"],
          onGridSizeChanged: (params:any) => {
            params.api.sizeColumnsToFit();
          },
          tooltipShowDelay: 100,
        };
        this.defaultColDef = {
          enableRowGroup: true, //ag-Grid-Enterprise
          enablePivot: true, //ag-Grid-Enterprise
          enableValue: true, //ag-Grid-Enterprise
          sortable: true,
          resizable: true,
          filter: false,
          tooltipComponent: TableHeaderToolTipComponent,
        };
    
  }

  ngOnInit(): void {  
    this.userId = this.auth.getUserId();
    console.log(this.transferType,'Edit Requisition Notes Component Initialized', this.data);
   
    this.requestTypeOption = this.data.requestTypeOption
   
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          console.log(this.type, "===this.translate");
          
           if(this.type == 'consignment'){
             this.getConsignmentData();
           }else{
            this.getRequsitionData();
           }

           if (this.requestTypeOption == "specificAssets") {
            this.push(
              this.assetService.getStatuses().subscribe((res: any) => {
                res.body.forEach((element: any) => {
                  statusesJS.push(element);
                });
              })
            );
          ;
          }
         
        }
      })
    );
  }

  getConsignmentData(){
  this.globalConsignmentService.getConsignmentById(this.data.id).subscribe((res:any) => {
   
    this.requisitionData = res.body.consignmentValues;
    this.requisitions = res.body.consignment;
    this.requisitionValues = res.body.consignmentValues;
    this.setBodyOptions()
  this.gotFromBin();
    this.selectedTransfer = this.requisitions.transferId ? {id:this.requisitions.transferId,transferNumber:this.requisitions.transferNumber}:null
     this.selectedToBinTransfer = {binDisplayName: this.requisitions.toBin.displayName, id: this.requisitions.toBin.id};
   
    this.spinner.hide();
   
  },
  (error: any) => {
    this.spinner.hide();
    console.log(error);
  }
  )
 }

 getRequsitionData(){
  this.globalRequisitionService.getRequisitionById(this.data.id).subscribe((res:any) => {
   
    this.requisitionData = res.body.requisitionValues;
    this.requisitions = res.body.requisition;
    this.requisitionValues = res.body.requisitionValues;

    this.requisitionValues.forEach((node) => {
      console.log(node.data,"===node.data");
      const id = node.id;
      this.selectedRows.push(node);
    });


    this.setBodyOptions();
    this.selectedTransfer = this.requisitions.transferId ? {id:this.requisitions.transferId,transferNumber:this.requisitions.transferNumber}:null
    this.selectedToBinTransfer = {binDisplayName: this.requisitions.toBin.displayName, id: this.requisitions.toBin.id};
    this.gotFromBin();
    this.spinner.hide();
   
  },
  (error: any) => {
    this.spinner.hide();
    console.log(error);
  }
  )
 }
 setBodyOptions() {
  
   if (this.requestTypeOption == "assetType") {
    this.requisitionValues  = [];
            this.getOtherData();
            this.requisitionData.forEach((element: any,index:any) => {
              this.addRow(index,element);
              });
                this.calculateTotalQuantity();
           
          }else if (this.requestTypeOption == "requestFromBin") {
            this.requisitionValues  = [];
            this.getProdyctType();
            this.requisitionData.forEach((element: any,index:any) => {
              this.addRow(index,element);
              
            });
            this.calculateTotalQuantity();
           
          }else if (this.requestTypeOption == "selectFromBin") {
            this.requisitionValues  = [];
            this.requisitionData.forEach((element: any,index:any) => {
              this.addRow(index,element);
              
            });
            this.calculateTotalQuantity();
           
          }else if (this.requestTypeOption == "custom") {
            this.requisitionValues  = [];
             this.requisitionData.forEach((element: any,index:any) => {
              this.addcustomFormRow(index,element);
              
            });
            this.calculateCustomFormTotalQuantity();
          } 
        }

  /******************************************** on get bin transfer table ******************************************/
  public gotFromBin() {
    //this.product.transferFromBin.id = $event.id;
    if (this.requestTypeOption == "specificAssets"){
      if(this.requisitionValues.length > 0){
       this.requisitionValues.forEach((node) => {
      const id = node.assets.id;
      this.selectedRowIds.add(id);
      this.selectedRows.push(node.assets);
    });
  }
      this.getAssetFromBIN();
       this.initializeColumns();
    }else if (this.requestTypeOption == "selectFromBin"){
  //     if(this.requisitionValues.length > 0){
  //      this.requisitionValues.forEach((node) => {
  //     const id = node.product.id;
  //     this.selectedRowIds.add(id);
  //     this.selectedRows.push(node.product);
  //   });
  // }

       this.getProductFromBIN();
  //      this.initializeColumns();
    }
    this.filteredBinPickList= null;
  
  }

//******************************************** Get All Product Type ******************************************/
  getProdyctType() {
    this.push(
      this.productService.getAllProductType().subscribe((res : any) => {
        this.productsType = res.sort((elementA: any, elementB: any) => {
          if (elementA?.order > elementB?.order) {
            return 1;
          }
  
          if (elementA?.order < elementB?.order) {
            return -1;
          }
  
          return 0;
        });
  
      }));

      this.productService.getAllProductFamilies().subscribe((res: any) => {
        this.productsFamilies = [...res];
      });
  }
/******************************************** Get All Asset Type and category ******************************************/
  getOtherData() {
    this.push(
      this.assetService.getTypes(true).subscribe((res: any) => {
        const allTypes = res.body.filter((t: any) => t.active);
        this.assetTypes = allTypes.sort((elementA: any, elementB: any) => {
          if (elementA.order > elementB.order) {
            return 1;
          }

          if (elementA.order < elementB.order) {
            return -1;
          }

          return 0;
        });
      })
    );

    this.assetService.getAllCategory().subscribe((res: any) => {
     this.categoryList = res;
    })
  
  }
/******************************************** Get All Asset Subcategory ******************************************/
  getSubCategory(event: any,index: any) {
    if(this.requisitionValues[index].category.id){
    this.assetService.getAllSubCategory(this.requisitionValues[index].category.id).subscribe((res: any) => {
      this.requisitionValues[index].subCatList = res.body;
    } )
  }else{
    this.requisitionValues[index].subCatList = null;
  }
  }

    /******************************************** Add Row ******************************************/
  
    addRow(index: any = null, element: any = null): void {
     
      var row= null;
console.log(element,"===this.requestTypeOption");

      if(this.requestTypeOption == "requestFromBin"  || this.requestTypeOption == "selectFromBin"){
        if(this.requestTypeOption == "requestFromBin"){
        row={
          id: element ? element.id : null,
          productType: element?.productType ? element.product.productType : {label: null},
          family: element && element.product?.productFamily ? element.product.productFamily.label : null,
          type:  null,
          model: element ? element.model : null,
          quantity: element ? element.quantity : 1,
          productId:element ? element.product.id : null,
          productName:element ? element.product.name : null,
          product: element ? element.product : null,
          productSku: element ? element.product.productSku : null,
        }
      }else if(this.requestTypeOption == "selectFromBin"){
        row={
        id: element ? element.id : null,
          productType: element?.product.productType ? element.product.productType : {label: null},
          family: element && element.product?.productFamily ? element.product.productFamily : {label: null},
          type:  null,
          model: element ? element.model : null,
          quantity: element ? element.quantity : 1,
          productId:element ? element.product.id : null,
          productName:element ? element.product.name : null,
          product: element ? element.product : {id:null},
          productSku: element ? element.product.productSku : null,
          newQuantity: 1,
        }
      }
        this.requisitionValues.push(row);

      var indexData= this.requisitionValues.length == 0 ? 0 : this.requisitionValues.length-1;
      var newIndex = index == null ? indexData : index;
      
        this.addAssetTypeForm[newIndex] = new UntypedFormGroup({
          'product': new UntypedFormControl(null,[Validators.required]),
          'productType': new UntypedFormControl(null,[Validators.required]),
          'quantity': new UntypedFormControl(1,[Validators.required, Validators.min(1), onlyWholeNumbersValidator()]),
         }); 
  
      }else if(this.requestTypeOption == "assetType"){
        var assetType = null
        if(element && element.assetsType){
          assetType = {id:element.assetsType.id} 
        }
       row={
        id: element ? element.id : null,
        assetType: assetType ? {id: assetType.id} : {id: null},
        category: element ? element.category : null,
        subCategory:  element ? element.subCategory : null,
        model: element  ? element.model : null,
        quantity: element ? element.quantity : 1
      }
      this.requisitionValues.push(row);
       var indexData= this.requisitionValues.length == 0 ? 0 : this.requisitionValues.length-1;
      var newIndex = index == null ? indexData : index;
     
      this.addAssetTypeForm[newIndex] = new UntypedFormGroup({
        'assetTypes': new UntypedFormControl(null,[Validators.required]),
        'quantity': new UntypedFormControl(1,[Validators.required, Validators.min(1), onlyWholeNumbersValidator()]),
       }); 
      }
      // this.addAssetTypeForm[newIndex].controls.quantity.valueChanges.subscribe(() => {
      //   console.log("Quantity changed");
        this.calculateTotalQuantity();
      // });
  console.log(this.requisitionValues, "===this.requisitionValues",this.addAssetTypeForm);
  
    }
    /******************************************** Delete Row ******************************************/
    deleteRow(index: number): void {
      console.log(index,"===index");
      var backup = _.cloneDeep(this.requisitionValues);
      backup.splice(index, 1);
      this.requisitionValues = backup;
       this.addAssetTypeForm.splice(index, 1);
      this.calculateTotalQuantity();
    }
   
  
    /******************************************** Add Row ******************************************/

    addcustomFormRow(index:any = null, element: any = null): void {
      var row={
        id: element ? element.id : null,
        description: element ? element.description : null,
        quantity: element ? element.quantity : 1,
       }
      this.requisitionValues.push(row);
       var indexData= this.requisitionValues.length == 0 ? 0 : this.requisitionValues.length-1;
      var newIndex = index == null ? indexData : index;
     
      
      this.addAssetTypeForm[this.requisitionValues.length-1] = new UntypedFormGroup({
        'description': new UntypedFormControl(null,[Validators.required]),
        'quantity': new UntypedFormControl(1,[Validators.required, Validators.min(1), onlyWholeNumbersValidator()]),
       }); 
      
      // this.addAssetTypeForm[this.requisitionValues.length-1].controls.quantity.valueChanges.subscribe(() => {
      //   console.log("Quantity changed");
        this.calculateCustomFormTotalQuantity();
     // });
  
    console.log(this.requisitionValues, "===this.requisitionValues");
    
     }
  
   /******************************************** Delete Row ******************************************/
   deletecustomFormRow(index: number): void {

     console.log(index,"===index");
      var backup = _.cloneDeep(this.requisitionValues);
      backup.splice(index, 1);
      this.requisitionValues = backup;
       this.addAssetTypeForm.splice(index, 1);
    this.calculateCustomFormTotalQuantity();
  }
  
  
    /******************************************** Calculate Total Quantity ******************************************/
  calculateTotalQuantity(): void {
  this.totalQuantity = 0; // Reset before summing
  this.requisitionValues.forEach(element => {
    // Make sure to handle empty or invalid values
    const qty = Number(element.quantity);
    this.totalQuantity += isNaN(qty) ? 0 : qty;
  });
}
    /******************************************** Calculate Total Quantity ******************************************/
  
    calculateCustomFormTotalQuantity(): void {
       this.totalCustomFormQuantity = 0; // Reset before summing
      this.requisitionValues.forEach(element => {
        // Make sure to handle empty or invalid values
        const qty = Number(element.quantity);
        this.totalCustomFormQuantity += isNaN(qty) ? 0 : qty;
      });

    }
   /******************************************** Toggle Filter View ******************************************/

  public toggleFilterView() {
    this.filterActive = !this.filterActive;
    console.log("toggle fil", this.filterActive);
    if (this.filterAPILoaded === false) {

     this.getOtherData()
      this.push(
        this.assetService.getStatuses(true).subscribe((res: any) => {
          console.log(res, "===res");
          
          this.assetstatuses = res.body.sort((elementA: any, elementB: any) => {
            if (elementA.order > elementB.order) {
              return 1;
            }

            if (elementA.order < elementB.order) {
              return -1;
            }

            return 0;
          });
        })
      );

      this.filterAPILoaded = true;
    }
  }
  /******************************************** Get Asset According to FROM BIN ******************************************/
  public getAssetFromBIN() {
    this.push(
      this.assetService.getAllAssetsforRequisition(this.requisitions.fromBin.id, this.filter).subscribe((res: any) => {
          this.assets = res.body;
          this.totalRecord = res.body.length;
          
        })
    );
  }
  
  /******************************************** Get Product According to FROM BIN ******************************************/
public getProductFromBIN() {
  this.push(
    this.assetService.getAllproductforRequisition(this.requisitions.fromBin.id, this.filter,this.searchValue).subscribe((res: any) => {
        this.productsData = res.body;
        this.productsData.forEach(element => {
           element.newQuantity = 1;
          element.family = element.productFamily ? element.productFamily : {label: null};
          element.productType = element.productType ? element.productType : {label: null};
        });
        this.requisitionValues.forEach((element:any,index:any) => {

        var check = _.filter(this.productsData, (o) => { return o.id == element.product.id })
        console.log(check,"===check");
          if(check.length > 0){
          this.requisitionValues[index].quantity = check[0].quantity
          
          }
        });
        this.totalRecord = res.body.length;
      })
  );
}

 /******************************************** Refresh Asset table ******************************************/
  onFilter() {
     if (this.requestTypeOption == "specificAssets"){
    
      this.getAssetFromBIN();
    }
  }

  /********************************** Initilize Grid Table **************************/
  onGridReady(params: any) {
    this.gridParams = params;
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    //console.log("translate",translateData,"=======",this.columnDefs)
  }

  /********************************** Initilize Grid Table colums **************************/
  initializeColumns() {
    this.columnDefs = [];
    this.overlayNoRowsTemplate =
      "<div class='not-found'><span>" +
      this.translate?.general.messages.noRecordsFound +
      "</span> </div>";
      var newData =[]
    //console.log("initiateCol", translateData, "=======", this.columnDefs)
    if(this.requestTypeOption == "specificAssets"){
     newData = [
      {
        headerName: this.translate?.asset.fields.serialNo.singular,
        field: "serialNo",
        width: 80,
        headerTooltip: "#",
      },
      {
        headerName: this.translate?.asset.label.singular,
        field: "name",
        width: 80,
        headerTooltip: "#",
       
      },
      {
        headerName: this.translate?.asset.fields.parent.singular,
        field: "parent",
        width: 80,
        headerTooltip: "#",
         cellRenderer: (params: any) =>{
          if (params.data) {
            if (params.data.parent) {
              return params.data.parent.name;
            } else {
              return "-";
            }
          }
        }
      },
      {
        headerName: this.translate?.asset.fields.type.singular,
        field: "assetsType.name",
        width: 80,
        headerTooltip: "#",
      },
      {
        headerName: this.translate?.asset.fields.status.singular,
        field: "assetsStatus.name",
        width: 80,
        headerTooltip: "#",
        cellRenderer: function (params: any) {
          if (params.data) {
            if (params.data.assetsStatus) {
              var data = { colorCode: "", name: "" };
              for (var i = 0; i < statusesJS.length; i++) {
                if (
                  String(params.data.assetsStatus.name) ==
                  String(statusesJS[i].name)
                ) {
                  data = statusesJS[i];
                  return (
                    ' <span class="p-mr-2  p-tag p-component" style="background-color:' +
                    data.colorCode +
                    "50 !important ;color:" +
                    "#212121" +
                    '"><span class="p-tag-value">' +
                    data.name +
                    "</span></span>"
                  );
                }
              }
            }
          }
        },
      },
      {
        width: 70,
        sortble: false,
        headerComponent: "selectAllComponent",
        headerComponentParams: {
          checkboxSelection: true,
        },
        checkboxSelection: true,

        cellRenderer: (params: any) => {
          //////////////
          if (params.data) {
            const id = params.data.id;
            console.log(this.selectedRowIds, "id", id);
            // Check if this row was previously selected
            if (this.selectedRowIds.has(id)) {
              params.node.setSelected(true);
            } else {
              params.node.setSelected(false);
            }
          }
        },
      },
    ];
  }
    this.columnDefs = newData;
   
      setTimeout(() => {
         if (this.gridApi) {
      this.gridApi.setColumnDefs(this.columnDefs);
        
        this.gridApi.sizeColumnsToFit();
      //  if(!this.initSelectedRows){
        this.syncSelectionWithFilteredData();
        
         }
      //  }
       // this.initSelectedRows = false;
      }, 1000);
    
  }

   syncSelectionWithFilteredData(): void {
    
    console.log( "Visible Selected Rows after Filter/Search:",this.selectedRows );
    console.log("All Selected IDs:", Array.from(this.selectedRowIds));
    
    // Re-apply selection state to visible nodes
    this.gridApi.forEachNode((node: any) => {
      const isSelected = this.selectedRowIds.has(node.data.id);
      node.setSelected(isSelected);
    });

    // Reset both selectedRows and selectedRowIds to only include filtered/visible selected data
    this.selectedRows = [];
    this.selectedRowIds.clear();

    this.gridApi.forEachNodeAfterFilter((node: any) => {
      if (node.isSelected()) {
        this.selectedRows.push(node.data);
        this.selectedRowIds.add(node.data.id);
      }
    });

    console.log(  "Visible Selected Rows after Filter/Search:", this.selectedRows );
    console.log("All Selected IDs:", Array.from(this.selectedRowIds));
  }

  /******************************************** on Selection Changed ******************************************/
onSelectionChanged(event: any): void {
    const selectedNodes = event.api.getSelectedNodes();

    // Clear previous selection tracking
    //this.selectedRowIds.clear();
    this.selectedRows = [];

    selectedNodes.forEach((node) => {
      const id = node.data.id;
      this.selectedRowIds.add(id);
      this.selectedRows.push(node.data);
    });

    console.log("Updated selected rows:", this.selectedRows);
  }

  /////////////////////////////// start(Product search component)////////////////////////////
        
      gotSelectedProduct(val: any,){
       this.selectProductFromTable(val);
       this.displayProductTable =false
     }
     closeProductView(){
       this.selectedIndex = null;
       this.displayProductTable =false
     }
     showProductTable(index: any){
       this.selectedIndex = index;
       console.log(this.selectedIndex)
       this.displayProductTable = !this.displayProductTable;
     }
     selectProductFromTable(value: any) {//after value select from grid
      
      console.log(this.selectedIndex,"===",value)
        var check = _.filter(this.requisitionValues, (o) => { return o.product?.id == value.id })
         if(check.length == 0){
  
          var checkProductType = null
          checkProductType = value.productType != null ?  _.filter(this.productsType, (o) => { return o.id == value.productType.id }) : null
          console.log(checkProductType,"===checkProductType")
         
             this.requisitionValues[this.selectedIndex].product = value;
             if(this.requestTypeOption === 'requestFromBin'){
              this.requisitionValues[this.selectedIndex].productType=checkProductType != null ? checkProductType[0] : null
               this.requisitionValues[this.selectedIndex].family = null
          
            
             }else if(this.requestTypeOption === 'selectFromBin'){
              this.requisitionValues[this.selectedIndex].productType=value.productType != null ? value.productType : {label:null}
              this.requisitionValues[this.selectedIndex].family = value.productFamily != null ? value.productFamily : {label:null}
              this.requisitionValues[this.selectedIndex].productSku = value.productSku != null ? value.productSku : null

             }
             this.requisitionValues[this.selectedIndex].productName=value.name
            
             this.products=[];
             this.requisitionValues[this.selectedIndex].quantity = 1
             this.requisitionValues[this.selectedIndex].hasError = 0
             console.log(this.requisitionValues[this.selectedIndex],"===this.requisitionValues")
           }else{
           this.errorUtil.setErrorMessage(200, this.translate?.inventory.messages.sameProductBinTransferNotAllowed,  null, 'error',3000);
         
         }
     }
     selectValueProduct(value: any,index: any) {
       
        var check = _.filter(this.requisitionValues, (o) => { return o.product.id == value.id })
       
     var checkProductType = _.filter(this.productsType, (o) => { return o.id == value.productType.id }) 
     
     console.log(check.length,"===",checkProductType)
  
          if(check.length == 0){
           this.requisitionValues[index].product.id = value.id;
           //this.onSelectProductData(value, index);
           this.requisitionValues[index].productName = value;
            this.requisitionValues[index].productType= check.length == 0  ?   null:checkProductType[0]
           this.requisitionValues[index].productName=value.name
            this.requisitionValues[index].family=null
           this.requisitionValues[index].showProductsDropDown = false;
           this.products=[];
           this.requisitionValues[index].quantity = 1
           this.requisitionValues[index].hasError = 0
         }else{
           this.clearProductValue(index)
           this.errorUtil.setErrorMessage(200, this.translate?.inventory.messages.sameProductBinNotAllowed,  null, 'error',3000);
         }
     }
     clearProductValue(index: any) {
       this.requisitionValues[index].product.id = null;
       this.requisitionValues[index].productName = null;
       this.requisitionValues[index].productType= null
       this.products = [];
       this.requisitionValues[index].family=null
       this.requisitionValues[index].qty = null
       this.requisitionValues[index].qtyTransfer = 0
       this.requisitionValues[index].hasError = 0
     
     }
     onvalidProduct(index: any){
       setTimeout(() => {
         console.log("We are checking data")
         if(this.requisitionValues[index].product.id==null){
           this.requisitionValues[index].productName = null;
         }
       }, 3000);
       
     }
     
     
     getProductIdsFirstWay(event: any, index: any) {
       console.log(this.requisitionValues[index].productName.length,"====",this.requisitionValues[index].productName)
         var k = event.key
       console.log(k)
       if (k == "Backspace") {
         this.requisitionValues[index].product.id = null;
     
       }
       if (this.requisitionValues[index].productName.length > 2) {
         this.productService.getProductPickListSearchable(this.requisitionValues[index].productName).subscribe((data:any) => {
           this.products = data;
          })
       
     }
     }
     /**************************************** end (product search component)***********************************/
    
    submitForm() {
    if(this.transferType =='header') {
    if(this.selectedToBinTransfer == null) {
        this.isFromBinInvalid = true;
      return
    }
    if(this.requisitions.status == "APPROVED" || this.requisitions.status == "TRANSFER_FULFILLED" || this.requisitions.status == "TRANSFER_PENDING") {

    if(this.selectedTransfer == null) {
            this.isTransferInvalid = true;
          return
        }
    }

   var url = '/consignments/update'
    if(this.type == 'requisition'){
     var url= "/requisitions/update"
    }
     var req={
        id: this.requisitions.id,
        comment: this.requisitions.notes,
        transferId: this.selectedTransfer ? this.selectedTransfer.id : null, 
        toBin: {id: this.selectedToBinTransfer.id} 
    }
    this.globalConsignmentService.updateConsignmentHeader(req,url).subscribe((res:any) => {
        console.log("------",res)
        if(res.status == 201 || res.status == 200){
         this.errorUtil.setErrorMessage(200, this.translate?.general.messages.updatedSuccessfully ,  null, 'success',1000);
          this.modalRef.hide()
        } else {
          const title = this.errorUtil.processErrorTitle(res.error,this.translate)
          this.errorUtil.setErrorMessage(res.status, null ,  title, 'error',3000);
          this.submitTouched = false;
          this.modalRef.hide()
        }
      },
      (err) => {
        this.spinner.hide()
       const title = this.errorUtil.processErrorTitle(err.error,this.translate)
       this.errorUtil.setErrorMessage(err.status, null ,  title, 'error',3000);
      
    })

  }else{
    
    this.submitHeaderForm()
  }
  
}

  submitHeaderForm() {
    var req = null
  
    if (this.requestTypeOption == "specificAssets") {

      console.log(this.selectedRows,"===this.selectedRows");
      if (this.selectedRows.length == 0 && this.transferType =='body') {
        var errorMessage = this.requestTypeOption == "specificAssets" ? this.translate?.requisition.messages.selectAssetToRequest : this.translate?.requisition.messages.selectSparePartToRequest;
        this.errorUtil.setErrorMessage( 200,  null,  errorMessage, "error",   3000 );
        return false;
      }

      var requisitionArray = [];
      this.selectedRows.forEach((row: any) => {
        var reqObj = { assets:{id: row.id},id: row.id }
        requisitionArray.push(reqObj);
      });
      req = {
        requisition: {
          id: this.requisitions.id,
          status: "PENDING",
          type: "ASSET",
          notes: this.requisitions.notes,
          fromBin: {
            id: this.requisitions.fromBin.id,
          },
          toBin: {
            id: this.selectedToBinTransfer.id,
          },
          requester: {
            id: Number(this.userId),
          },
           transferId: this.selectedTransfer ? this.selectedTransfer.id : null,
        transferNumber: this.selectedTransfer ? this.selectedTransfer.transferNumber : null,
        },
        requisitionValues: requisitionArray,
      };
      console.log(this.type,"Requisition Data", req);
    }else if (this.requestTypeOption == "assetType") {
      var requisitionArray = [];
      this.requisitionValues.forEach((row: any) => {
        var reqObj = {
          assetsType: { id: row.assetType.id },
          quantity: row.quantity,
          category: row.category ? { id: row.category.id }: null,
          subCategory: row.subCategory ? { id: row.subCategory.id }: null,
          model: row.model,
          id: row.id
        };
        requisitionArray.push(reqObj);
      });
      req = {
        requisition: {
          id: this.requisitions.id,
          status: "PENDING",
          type: "OTHER_ASSETS",
          notes: this.requisitions.notes,
          fromBin: {
            id: this.requisitions.fromBin.id,
          },
          toBin: {
            id: this.selectedToBinTransfer.id,
          },
          requester: {
            id: this.requisitions.requester ? this.requisitions.requester.id:this.requisitions.giver.id,
          },
           transferId: this.selectedTransfer ? this.selectedTransfer.id : null,
        transferNumber: this.selectedTransfer ? this.selectedTransfer.transferNumber : null,
        },
        requisitionValues: requisitionArray,
      };
      //console.log(this.type,"Requisition Data", req);
    } else if (this.requestTypeOption == "custom") {
      if (this.requisitionValues.length == 0) {
        var errorMessage =  this.translate?.requisition.messages.selectSparePartToRequest;
        this.errorUtil.setErrorMessage( 200,  null,  errorMessage, "error",   3000 );
        return false;
      }else if ( this.addAssetTypeForm.some(formGroup => !formGroup.valid)) {
        this.addAssetTypeForm.forEach(formGroup => formGroup.markAllAsTouched());
        return false;
      }
      var requisitionArray:any[] = [];
       var reqObj = null;
      this.requisitionValues.forEach((row: any) => {
        if(row.id == null){
           reqObj = { description: row.description, quantity: row.quantity }
        }else{
           reqObj = { id: row.id, description: row.description, quantity: row.quantity }
        }
        requisitionArray.push(reqObj);
      })
      req = {
        requisition: {
          id: this.requisitions.id,
          status: "PENDING",
          type: "OTHERS",
          notes:this.requisitions.notes,
          fromBin: {
            id: this.requisitions.fromBin.id,
          },
          toBin: {
            id: this.selectedToBinTransfer.id,
          },
          requester: {
            id: this.requisitions.requester ? this.requisitions.requester.id : this.requisitions.giver.id,
          },
           transferId: this.selectedTransfer ? this.selectedTransfer.id : null,
        transferNumber: this.selectedTransfer ? this.selectedTransfer.transferNumber : null,
        },
        requisitionValues: requisitionArray,
        transferId: this.selectedTransfer ? this.selectedTransfer.id : null,
        transferNumber: this.selectedTransfer ? this.selectedTransfer.transferNumber : null,
      };
    }else if (this.requestTypeOption == "selectFromBin") {
      
      // if (this.requisitionValues.length == 0) {
      //   var errorMessage = this.requestTypeOption == "specificAssets" ? this.translate?.requisition.messages.selectAssetToRequest : this.translate?.requisition.messages.selectSparePartToRequest;
      //   this.errorUtil.setErrorMessage( 200,  null,  errorMessage, "error",   3000 );
      //   return false;
      // }else 
     
      var check = _.filter(this.addAssetTypeForm, (o) => {
        return o.status == 'INVALID';
      })
      console.log(this.addAssetTypeForm,"====",check.length )
      if(check.length > 0){
        //console.log("Step 1====")
        this.addAssetTypeForm.forEach(form => {
          if(!form.valid){
            for (var i in form.controls) {
              form.controls[i].markAsTouched();
            }
          }
        });
       return;
      }


      var requisitionArray = [];
      this.requisitionValues.forEach((row: any) => {
        var reqObj = { product:{id: row.product.id},quantity: row.newQuantity,id: row.id }
        requisitionArray.push(reqObj);
      });
      req = {
        requisition: {
          id: this.requisitions.id,
          status: "PENDING",
          type: "PRODUCT",
          notes: this.requisitions.note,
          fromBin: {
            id: this.requisitions.fromBin.id,
          },
          toBin: {
            id: this.selectedToBinTransfer.id,
          },
          requester: {
            id: this.userId,
          },
           transferId: this.selectedTransfer ? this.selectedTransfer.id : null,
        transferNumber: this.selectedTransfer ? this.selectedTransfer.transferNumber : null,
        },
        requisitionValues: requisitionArray,
      };
      console.log(this.type,"Requisition Data", req);
    } else if (this.requestTypeOption == "requestFromBin") {

      if (this.requisitionValues.length == 0) {
        var errorMessage =  this.translate?.requisition.messages.selectSparePartToRequest;
        this.errorUtil.setErrorMessage( 200,  null,  errorMessage, "error",   3000 );
        return false;
      }else if ( this.addAssetTypeForm.some(formGroup => !formGroup.valid)) {
        this.addAssetTypeForm.forEach(formGroup => formGroup.markAllAsTouched());
        return false;
      }
      console.log(this.requisitionValues,"===this.requisitionValues");
     // ;
      var requisitionArray = [];
      this.requisitionValues.forEach((row: any) => {
        var reqObj = { product:{id: row.id} }
        requisitionArray.push(reqObj);
      });
      req = {
        requisition: {
          id: this.requisitions.id,
          status: "PENDING",
          type: "OTHER_PRODUCT",
          notes: this.requisitions.notes,
          fromBin: {
            id: this.requisitions.fromBin.id,
          },
          toBin: {
            id: this.selectedToBinTransfer.id,
          },
          requester: { id: this.userId  },
           transferId: this.selectedTransfer ? this.selectedTransfer.id : null,
        transferNumber: this.selectedTransfer ? this.selectedTransfer.transferNumber : null,
        },
        requisitionValues: this.requisitionValues,
      };
      console.log(this.type,"Requisition Data", req);
    }    
    console.log("Requisition Data", req," ___________",this.type);

    if(this.type == 'consignment'){
      var newRqr = {
        consignment: req.requisition,
        consignmentValues: req.requisitionValues,
      };
      newRqr.consignment.giver = {id:newRqr.consignment.requester.id};
      this.saveConsignment(newRqr);
    }else if(this.type == 'requisition'){
      this.saveRequisition(req);
    }

  }
  saveConsignment(req) {
    console.log("saveConsignment");
      this.globalConsignmentService.updateConsignment(req).subscribe((res:any) => {
        console.log("------",res)
        if(res.status == 201 || res.status == 200){
         this.errorUtil.setErrorMessage(200, this.translate?.general.messages.updatedSuccessfully ,  null, 'success',1000);
          this.modalRef.hide()
        } else {
          const title = this.errorUtil.processErrorTitle(res.error,this.translate)
          this.errorUtil.setErrorMessage(res.status, null ,  title, 'error',3000);
          this.submitTouched = false;
          this.modalRef.hide()
        }
      },
      (err) => {
        this.spinner.hide()
       const title = this.errorUtil.processErrorTitle(err.error,this.translate)
       this.errorUtil.setErrorMessage(err.status, null ,  title, 'error',3000);
      
    })
   

  }
  saveRequisition(req) {
    console.log("saveRequisition");
      this.globalRequisitionService.updateRequisition(req).subscribe((res:any) => {
        console.log(res,"======")
        if(res.status == 201 || res.status == 200){
         this.errorUtil.setErrorMessage(200, this.translate?.general.messages.updatedSuccessfully ,  null, 'success',1000);
         this.modalRef.hide()
        } else {
          const title = this.errorUtil.processErrorTitle(res.error,this.translate)
          this.errorUtil.setErrorMessage(res.status, null ,  title, 'error',3000);
          this.submitTouched = false;
        }
      },
      (err) => {
        this.spinner.hide()
       const title = this.errorUtil.processErrorTitle(err.error,this.translate)
       this.errorUtil.setErrorMessage(err.status, null ,  title, 'error',3000);
      
    })
   

  }
 /******************************************** on get bin transfer table ******************************************/
 public gotToBin($event: any) {
  //this.product.transferFromBin.id = $event.id;
  this.selectedToBinTransfer = $event;
  this.requisitions.toBin = $event;
  console.log(this.selectedToBinTransfer);
}

   /******************************************** autocomplete for bin transfer results ******************************************/
   public getAllToBin($event: any) {
    const query = $event.query.toLowerCase() as string;

    if (query && query.length > 2) {
      const filter = this.TobinPickList.filter((bin) => {
        const displayName = bin.binDisplayName.toLowerCase() as string;

        if (displayName.includes(query)) {
          return true;
        }

        return false;
      });

      this.filteredToBinPickList = [...filter];
    } else {
      this.filteredToBinPickList = [...this.TobinPickList];
    }
  }

  /******************************************** on select bin transfer autocomplete ******************************************/
  private getToBinPickList() {
    this.push(
      this.inventoryServices.getRequisitionToBin(null, this.userId).subscribe((res: any) => {
          this.TobinPickList = res;
        })
    );
  }

  /******************************************** clear bin transfer ******************************************/
  public clearToBinTransfer() {
    this.selectedToBinTransfer = null;
  }

  /******************************************** show bin transfer table ******************************************/
  public displayToBinTransferTable() {
    this.showToBinTransferTable = true;
  }

  /******************************************** close bin tranfer table ******************************************/
  public closeToBinTransferTable() {
    this.showToBinTransferTable = false;
  }

  /******************************************** on bin transfer table ******************************************/
  public gotToBinTransferAtTable($event: any) {
    this.selectedToBinTransfer = $event;
    console.log(this.selectedToBinTransfer);
    //this.getAssetFromBIN();
    this.closeToBinTransferTable();
  }


  /******************************************** on bin transfer table ******************************************/
  push(obs: any) {
    super.push(obs);
  }
 enforceMaxLength(event: any, row: any, maxLength: number) {
  let value = event.target.value?.toString() || '';
  // Remove non-digit characters (optional, for stricter enforcement)
  value = value.replace(/\D/g, '');
  if (value.length > maxLength) {
    value = value.slice(0, maxLength);
    event.target.value = value;
    row.quantity = Number(value);
    console.log(row.quantity, "===row.quantity");
   
  } else {
    row.quantity = Number(value);
     this.calculateTotalQuantity();
  }
}
enforceMaxLength2(event: any, row: any, maxLength: number) {
  let value = event.target.value?.toString() || '';
  // Remove non-digit characters (optional, for stricter enforcement)
  value = value.replace(/\D/g, '');
  if (value.length > maxLength) {
    value = value.slice(0, maxLength);
    event.target.value = value;
    row.newQuantity = Number(value);
    console.log(row.newQuantity, "===row.quantity");
   
  } else {
    row.newQuantity = Number(value);
     this.calculateTotalQuantity();
  }
}
enforceMaxLengthCustom(event: any, row: any, maxLength: number) {
  let value = event.target.value?.toString() || '';
  // Remove non-digit characters (optional, for stricter enforcement)
  value = value.replace(/\D/g, '');
  if (value.length > maxLength) {
    value = value.slice(0, maxLength);
    event.target.value = value;
    row.quantity = Number(value);
    console.log(row.quantity, "===row.quantity");
   
  } else {
    row.quantity = Number(value);
     this.calculateCustomFormTotalQuantity();
  }
}
/////////////////////////////////////////////////////// Transfer Table Functions //////////////////////////////////////////////////////

 /******************************************** on get  transfer table ******************************************/
 public onSelectTransferData($event: any) {
  //this.product.transferFromBin.id = $event.id;
  this.selectedTransfer = $event;
}

  

  /******************************************** on select bin transfer autocomplete ******************************************/
  private getTransferData(event: any) {
       var k = event.key
     console.log(k)
     if (k == "Backspace") {
       this.selectedTransfer = null;

     }
    const query = event.query.replace(
      /[&\/\\#,+()$~%!.„'":*‚^_¤?<>|@ª{«»§}©®™ ]/g,
      ""
    );

    if (query && query.length > 2) {
      var serverRequest: any = {
        startRow: 0,
        pageSize: 25,
        filterModel: null,
        sortModel: [{ colId: "id", sort: "asc" }]
      }
    this.push(
      this.inventoryServices.getAllBinTransfer(query, serverRequest ,null).subscribe((res: any) => {
          this.transferPicklist = res.body.data;
        })
    );
  }
}

  /******************************************** clear bin transfer ******************************************/
  public clearTransfer() {
    this.selectedTransfer = null;
  }

  /******************************************** show bin transfer table ******************************************/
  public displayTransferTable() {
    this.showTransferTable = true;
  }

  /******************************************** close bin tranfer table ******************************************/
  public closeTransferTable() {
    this.showTransferTable = false;
  }

  /******************************************** on bin transfer table ******************************************/
  public gotTransferAtTable($event: any) {
    this.selectedTransfer = $event;
    console.log(this.selectedTransfer);
    //this.getAssetFromBIN();
    this.closeTransferTable();
  }
  /******************************************** on bin transfer table ******************************************/

  public onSearch() {
    if (this.searchValue.length == 0) {
      this.searchValueData = false;
      this.searchValue = "";
      this.quickSearch();
    }
  }
  public onClear() {
    this.searchValueData = false;
    this.searchValue = "";
    this.quickSearch();
  }
   /********************************** Search asset Data **************************/
  quickSearch() {
    if (this.searchValue.length < 0) {
      console.log(this.searchValue, "===searchValue");
      // this.onFilter()
      this.searchValueData = true;
     this.gridApi.setGridOption("quickFilterText", this.searchValue);
      this.totalRecord = this.gridApi.getDisplayedRowCount();
      if (this.totalRecord == 0) {
        this.gridParams.api.showNoRowsOverlay();
      } else {
        this.gridParams.api.hideOverlay();
      }
    } else {
      this.gridApi.setGridOption("quickFilterText", this.searchValue);
      this.totalRecord = this.gridApi.getDisplayedRowCount();
      this.gridParams.api.hideOverlay();
    }
   
    this.syncSelectionWithFilteredData();
  }
   /********************************** Clear all Selected assets **************************/
  clearSelect() {
    this.selectedRows = [];
    this.selectedRowIds.clear();
    this.selectAllChecked = false;
     // Uncheck all rows and header checkbox in the grid
  this.gridSelectionService.clearSelectAll$.next();
  

     setTimeout(() => {
        this.gridApi.sizeColumnsToFit();
        this.syncSelectionWithFilteredData();
      }, 500);
  }

  onChangeProduct(value: any,index: any,event: any) {
       console.log(this.requisitionValues,"===",event.value)
      
        var check = _.filter(this.productsData, (o) => { return o.id == event.value })
      //  value.product.id = event.value
     var checkProduct = _.filter(this.requisitionValues, (o) => { return o.product.id == event.value }) 
     console.log(check,"===",checkProduct)
    
          if(checkProduct.length == 0){
           this.requisitionValues[index].product.id = event.value;
            this.requisitionValues[index].productType= check[0].productType  ? check[0].productType: {label:null}
           this.requisitionValues[index].productName = check[0].name
            this.requisitionValues[index].family=check[0].productFamily  ? check[0].productFamily: {label:null}
           this.requisitionValues[index].productSku =check[0].productSku;
           this.requisitionValues[index].quantity = check[0].quantity
           this.requisitionValues[index].hasError = 0
           this.requisitionValues[index].newQuantity = 1
            console.log(check,"===", this.requisitionValues[index])
  
         }else{
          this.addAssetTypeForm[index].get('product').setValue(null);
           this.requisitionValues[index].product.id = null;
            this.requisitionValues[index].productType= {label:null}
            this.requisitionValues[index].family={label:null}
            this.requisitionValues[index].productSku = null
            this.requisitionValues[index].qty = null
            this.requisitionValues[index].qtyTransfer = 0
            this.requisitionValues[index].quantity =null
            this.requisitionValues[index].hasError = 0
            this.requisitionValues[index].newQuantity = 0
           this.errorUtil.setErrorMessage(200, this.translate?.inventory.messages.sameProductBinNotAllowed,  null, 'error',3000);
         }
     }


  checkQtyError(row: any,index:any): void {
  if( Number(row.newQuantity) > Number(row.quantity)){
     row.newQuantity = 1;
     // Also update the form control directly
    const formControl = this.addAssetTypeForm[index]?.get('quantity');
    if (formControl) {
      formControl.setValue(1);
      formControl.markAsTouched();
      formControl.markAsDirty();
    }

    this.errorUtil.setErrorMessage(200, null, " Quantity exceeds available stock", "error", 3000);
    this.selectedRows[index].newQuantity = Number(0);
   
  }
}
}
